/** Default report period: previous calendar month (January rolls to December of prior year). */
export const getDefaultReportPeriod = () => {
  const date = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
  return {
    month: date.getMonth() + 1,
    year: date.getFullYear(),
  };
};

const defaultReportPeriod = getDefaultReportPeriod();
export const DEFAULT_REPORT_MONTH = defaultReportPeriod.month;
export const DEFAULT_REPORT_YEAR = defaultReportPeriod.year;
